// "adjustment_frequencies": {
//   "500_Hz": 600,
//   "1000_Hz": 1800,
//   "2000_Hz": 2700,
//   "4000_Hz": 3500,
//   "8000_Hz": 6000
// },

export const AutoFitData = {
  500: {
    0: "0x20",
    5: "0x20",
    10: "0x21",
    15: "0x21",
    20: "0x23",
    25: "0x23",
    30: "0x25",
    35: "0x25",
    40: "0x26",
    45: "0x27",
    50: "0x29",
    55: "0x2A",
    60: "0x2B",
    65: "0x2B",
    70: "0x2A",
    75: "0x2C",
    80: "0x2D",
    85: "0x2D",
    90: "0x2E",
    95: "0x2E",
    100: "0x2F",
  },
  1000: {
    0: "0x30",
    5: "0x30",
    10: "0x31",
    15: "0x31",
    20: "0x33",
    25: "0x33",
    30: "0x35",
    35: "0x35",
    40: "0x36",
    45: "0x37",
    50: "0x38",
    55: "0x39",
    60: "0x3A",
    65: "0x3A",
    70: "0x3B",
    75: "0x3C",
    80: "0x3D",
    85: "0x3D",
    90: "0x3E",
    95: "0x3E",
    100: "0x3F",
  },
  2000: {
    0: "0x70",
    5: "0x70",
    10: "0x71",
    15: "0x71",
    20: "0x73",
    25: "0x73",
    30: "0x75",
    35: "0x75",
    40: "0x76",
    45: "0x76",
    50: "0x76",
    55: "0x78",
    60: "0x79",
    65: "0x7A",
    70: "0x7B",
    75: "0x7B",
    80: "0x7C",
    85: "0x7C",
    90: "0x7D",
    95: "0x7E",
    100: "0x7F",
  },
  4000: {
    0: "0x50",
    5: "0x50",
    10: "0x53",
    15: "0x53",
    20: "0x55",
    25: "0x55",
    30: "0x58",
    35: "0x58",
    40: "0x59",
    45: "0x59",
    50: "0x5A",
    55: "0x5A",
    60: "0x5B",
    65: "0x5B",
    70: "0x5C",
    75: "0x5C",
    80: "0x5D",
    85: "0x5D",
    90: "0x5E",
    95: "0x5E",
    100: "0x5F",
  },
  8000: {
    0: "0x60",
    5: "0x60",
    10: "0x62",
    15: "0x62",
    20: "0x64",
    25: "0x64",
    30: "0x65",
    35: "0x67",
    40: "0x6A",
    45: "0x6A",
    50: "0x6B",
    55: "0x6C",
    60: "0x6D",
    65: "0x6D",
    70: "0x6E",
    75: "0x6E",
    80: "0x6F",
    85: "0x6F",
    90: "0x6F",
    95: "0x6F",
    100: "0x6F",
  },
};
